export default __webpack_public_path__ + "static/values-take-ownership-de27ff0fe2f87960b83b9bbfa293e18c.svg";